import api from "./api"


// =========================================================
// HELPERS
// =========================================================

const cleanParams = (
  params = {}
) =>
  Object.fromEntries(
    Object.entries(
      params
    ).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== "" &&
        value !== "all"
    )
  )


// =========================================================
// FORM DATA
// =========================================================

export const getReportingFormData =
  async () => {
    const response =
      await api.get(
        "/reporting/form-data"
      )

    return response.data
  }


// =========================================================
// SALES REPORTING
// =========================================================

export const getSalesSummaryReport =
  async (
    params = {}
  ) => {
    const response =
      await api.get(
        "/reporting/sales-summary",
        {
          params:
            cleanParams(
              params
            ),
        }
      )

    return response.data
  }


export const getTopProductsReport =
  async (
    params = {}
  ) => {
    const response =
      await api.get(
        "/reporting/top-products",
        {
          params:
            cleanParams(
              params
            ),
        }
      )

    return response.data
  }


export const getTopClientsReport =
  async (
    params = {}
  ) => {
    const response =
      await api.get(
        "/reporting/top-clients",
        {
          params:
            cleanParams(
              params
            ),
        }
      )

    return response.data
  }


export const getTopStoresReport =
  async (
    params = {}
  ) => {
    const response =
      await api.get(
        "/reporting/top-stores",
        {
          params:
            cleanParams(
              params
            ),
        }
      )

    return response.data
  }


export const getSalesByLocationReport =
  async (
    params = {}
  ) => {
    const response =
      await api.get(
        "/reporting/sales-by-location",
        {
          params:
            cleanParams(
              params
            ),
        }
      )

    return response.data
  }


// =========================================================
// STOCK REPORTING
// =========================================================

export const getStockCurrentReport =
  async (
    params = {}
  ) => {
    const response =
      await api.get(
        "/reporting/stock-current",
        {
          params:
            cleanParams(
              params
            ),
        }
      )

    return response.data
  }


export const getLowStockReport =
  async (
    params = {}
  ) => {
    const response =
      await api.get(
        "/reporting/low-stock",
        {
          params:
            cleanParams(
              params
            ),
        }
      )

    return response.data
  }


export const getStockMovementsReport =
  async (
    params = {}
  ) => {
    const response =
      await api.get(
        "/reporting/stock-movements",
        {
          params:
            cleanParams(
              params
            ),
        }
      )

    return response.data
  }


export const getAuditVariancesReport =
  async (
    params = {}
  ) => {
    const response =
      await api.get(
        "/reporting/audit-variances",
        {
          params:
            cleanParams(
              params
            ),
        }
      )

    return response.data
  }


// =========================================================
// FINANCE / CONTROL REPORTING
// =========================================================

export const getFinancialSummaryReport =
  async (
    params = {}
  ) => {
    const response =
      await api.get(
        "/reporting/financial-summary",
        {
          params:
            cleanParams(
              params
            ),
        }
      )

    return response.data
  }


export const getOpenDebtsReport =
  async (
    params = {}
  ) => {
    const response =
      await api.get(
        "/reporting/open-debts",
        {
          params:
            cleanParams(
              params
            ),
        }
      )

    return response.data
  }


export const getStoreReconciliationReport =
  async (
    params = {}
  ) => {
    const response =
      await api.get(
        "/reporting/store-reconciliation-summary",
        {
          params:
            cleanParams(
              params
            ),
        }
      )

    return response.data
  }
